// extracted by mini-css-extract-plugin
export var actionButtonsContainer = "_ju-0";
export var animationContainer = "_ju-1";
export var modalContent = "_ju-2";
export var orderName = "_ju-3";
export var refundOption = "_ju-4";
export var refundOptionsContainer = "_ju-5";